import React, { useState } from "react";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Textfield } from "./Textfield";

export function PasswordInput(props) {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    }
    return <Textfield
        {...props}
        type={showPassword ? 'text' : 'password'}
        inputProps={{
            autoComplete: 'new-password'
        }}
        InputProps={{
            endAdornment:
                (<InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                </InputAdornment>)
        }} 
        />
}